export default __webpack_public_path__ + "static/media/elevate-new-min.d8d7ea83.jpg";